module.exports = __webpack_public_path__ + "img/PaulCroeger.55e3b19a.jpg";